import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function BusinessContract({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>BusinessContract</title>
      <path
        d="M20.629 14.3301L14.7607 15.5045"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.339 8.84802L12.5685 10.0175C12.3501 10.108 12.1154 10.1531 11.8789 10.1499C11.6424 10.1468 11.4091 10.0955 11.1931 9.99912C10.9742 9.9009 10.7769 9.76032 10.6126 9.58547C10.4482 9.41063 10.3202 9.20499 10.2357 8.98041C10.0696 8.55356 10.0659 8.08058 10.2255 7.65123C10.385 7.22188 10.6966 6.86603 11.1012 6.65123L13.8704 5.26844C14.1701 5.11405 14.4988 5.02404 14.8353 5.00419C15.1718 4.98435 15.5087 5.0351 15.8245 5.1532L21.5114 7.39412"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.0166 15.5509V15.5509C5.28888 15.5509 6.52592 15.9689 7.53746 16.7405L9.09425 17.9282C9.50759 18.2435 9.88002 18.7018 10.3983 18.7424V18.7424C10.6613 18.763 10.9221 18.6806 11.1255 18.5126L16.3478 14.2C16.5542 14.0291 16.686 13.7848 16.7155 13.5185C16.7451 13.2522 16.6699 12.9849 16.5059 12.773L13.6288 9.57471"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.8017 6.847L10.4989 6.60182C10.1984 6.38084 9.8465 6.24011 9.47649 6.19292C9.10649 6.14574 8.73056 6.19364 8.38422 6.33213L4.00781 8.18811"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.0004 16.4706H2.60645C2.97533 16.4903 3.33705 16.3634 3.61266 16.1174C3.88826 15.8714 4.05537 15.5264 4.07751 15.1576V8.58934C4.05537 8.22059 3.88826 7.87557 3.61266 7.6296C3.33705 7.38362 2.97533 7.25665 2.60645 7.27642H3.0004"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.1009 16.4706C21.7321 16.4903 21.3703 16.3634 21.0947 16.1174C20.8191 15.8714 20.652 15.5264 20.6299 15.1576V8.58934C20.652 8.22059 20.8191 7.87557 21.0947 7.6296C21.3703 7.38362 21.7321 7.25665 22.1009 7.27642"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
